module.exports = __webpack_public_path__ + "img/news.8c0b4bd0.png";